import * as React from 'react';
import { connect } from 'react-redux';
import * as AppActions from '../actions/App';
import * as EventActions from '../actions/Event';
import * as ProfileActions from '../actions/Profile';
import * as RegistrationActions from '../actions/Registration';
import * as LoginActions from '../actions/Login';
import Typography from '@material-ui/core/Typography';
import MuiLink from '@material-ui/core/Link';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';
import { Link } from "react-router-dom";
import { format } from 'date-fns';
import { makeStyles } from '@material-ui/core/styles';
import RegistrationDialog from '../components/RegistrationDialog';
import LoginDialog from '../components/LoginDialog';
import Alert from '@material-ui/lab/Alert';
import Title from 'reactjs-title'
import config from '../../shared/config';

const useStyles = makeStyles((theme) => ({
  root: {
    color: theme.palette.common.white,
    backgroundColor: 'rgba(0,0,0, 0.6)',
    paddingBottom: 20,
    textShadow: '1px 1px 2px rgba(50, 50, 50, 0.7)',
    textAlign:'center',
    lineHeight: 3,
    letterSpacing: '0.5px',
    '& .description': {
      backgroundColor: 'rgba(0,0,0, 0.5)',
      padding: 10,
      textAlign: 'left',
      fontSize: '14px',
      lineHeight: 1.2,
      '& p, & ul,& ol': {
        marginTop: 0,
        marginBottom: 0,
      },
      '& a': {
        color: '#b3e5fc',
      },
      '& img': {
        maxWidth: '100%',
      }
    },
    '& .MuiTypography-body1': {
      fontSize: '1.2rem',
    },
    '& .MuiButton-root': {
      color: theme.palette.common.white,
      letterSpacing: '1px',
      borderColor: theme.palette.common.white,
      backgroundColor: 'rgba(255,255,255,0.2)',
      display: 'block',
      width: 280,
      margin: '20px auto',
      boxShadow: '1px 1px 2px rgba(50, 50, 50, 0.7)',
      '&:hover' : {
        backgroundColor: 'rgba(255,255,255,0.1)',
      }
    },
    '& .MuiButton-text': {
      fontSize: '1em',
      width: 280,
      textTransform: 'none',
      color: '#fff9c4',
      borderColor: '#fff9c4',
      backgroundColor: '#212121',
      borderWidth: 1,
      borderStyle: 'solid',
      boxShadow: 'none',
      letterSpacing: '1px',
      fontWeight: '100',
    },
    '& .info': {
      color: theme.palette.common.white,
      borderColor: theme.palette.common.white,
      backgroundColor: 'rgba(255,255,255,0.2)',
      display: 'block',
      width: 300,
      borderRadius: 3,
      margin: '20px auto',
      boxShadow: '1px 1px 2px rgba(50, 50, 50, 0.7)',
      border: `solid 1px ${theme.palette.common.white}`,
    },
    '& .MuiAlert-standardSuccess': {
      fontSize: '1.1rem',
      width: 300,
      backgroundColor: 'rgba(237, 247, 237, 0.2)',
      margin: '10px auto',
      border: 'solid 1px rgba(237, 247, 237, 1)',
      color: 'rgba(237, 247, 237, 1)',
      '& .MuiAlert-icon': {
        color: 'rgba(237, 247, 237, 1)',
      }
    }
  },
}));

function Wrap(props) {
  const classes = useStyles();
  return <div className={classes.root}>{props.children}</div>;
}


class EventPage extends React.Component {
  async componentDidMount() {
    console.log("Loading Event with id", config.eventId);
    this.props.setAppLoading(true);
    this.props.setEventId(config.eventId);
    this.props.enableBG();
    await this.props.loadProfile();
    await this.props.fetchRegistration();
    this.props.setAppLoading(false);
  }

  componentWillUnmount() {
    this.props.disableBG();
  }

  renderRegisterAction() {
    return (<>
          <Button variant='outlined' size="large" onClick={this.props.register}>Register</Button>
          <Button onClick={this.props.login} size="small">Already registered? - Check in</Button>
      </>);

  }

  renderAction() {
    if((this.props.status == 'live') || (this.props.status == 'preview' )) {
      if( this.props.registered ) {
        return (<Button component={Link} to={`/events/${this.props.event.data.slug}/lobby`} variant='outlined' size="large">Enter</Button>);
      }else {
        return this.renderRegisterAction();
      }
    }

    if((this.props.status == 'upcoming')) {
      if( this.props.registered ) {
        return (<Alert severity="success">You are registered to attend</Alert>);
      }
      return this.renderRegisterAction();
    }

    if(this.props.status == 'expired') {
      return (<Typography className='info' variant='body1'>This event has expired</Typography>);
    }
  }

  renderSimple() {
    return (<>
        <img src={this.props.logoURL} alt='Logo' style={{maxWidth: '80vw', visibility: (this.props.logoURL ? 'visible' : 'hidden')}} />
        <Title render={`${this.props.eventTitle} - ${this.props.eventSubtitle}`} />
        <Typography variant='h1' gutterBottom>{this.props.eventTitle}</Typography>
        <Typography variant='h2' gutterBottom>{this.props.eventSubtitle}</Typography>
        { this.props.eventDate ?
        (<>
        <Typography variant='body1' component='span'>
          { format(this.props.eventDate, 'LLLL d, yyyy') }
        </Typography>&nbsp;&nbsp;
        <Typography variant='body1' component='span'>
          { this.props.event.data.start_time_str }
          &nbsp;to&nbsp;
          { this.props.event.data.end_time_str }
          &nbsp; {this.props.event.data.timezone}
        </Typography>
        {this.renderAction()}
        </>)
        : '' }
    </>);
  }

  raw(html) {
    return <div dangerouslySetInnerHTML={{__html: html}}></div>;
  }

  renderLong() {
    return (<>
      <Grid container>
        <Grid item xs={12} sm={6}>
          <div style={{ margin: 20}}>
            <img src={this.props.logoURL} alt='Logo' style={{maxWidth: '200px', visibility: (this.props.logoURL ? 'visible' : 'hidden')}} />
            <Title render={`${this.props.eventTitle} - ${this.props.eventSubtitle}`} />
            <Typography variant='h1' gutterBottom>{this.props.eventTitle}</Typography>
            <Typography variant='h2' gutterBottom>{this.props.eventSubtitle}</Typography>
            { this.props.eventDate ?
                (<>
                <Typography variant='body1' component='span'>
                  { format(this.props.eventDate, 'LLLL d, yyyy') }
                </Typography>&nbsp;&nbsp;
                <Typography variant='body1' component='span'>
                  { this.props.event.data.start_time_str }
                  &nbsp;to&nbsp;
                  { this.props.event.data.end_time_str }
                  <br/> {this.props.event.data.timezone}
                </Typography>
                </>)
                : '' }
            {this.renderAction()}
          </div>
        </Grid>
        <Grid item xs={12} sm={6}>
          <div style={{ margin: 20}}>
            <div className="description" >{this.raw(this.props.description)}</div>
          </div>
        </Grid>
      </Grid>
      <Hidden smUp>
        {this.renderAction()}
      </Hidden>
    </>);
  }

  render() {
    if( ! this.props.loaded ) {
      return <>Loading...</>;
    }
    return (
      <div style={{paddingTop: 20,paddingBottom: 40}}>
        <RegistrationDialog />
        <LoginDialog />
        <Wrap>
          { (this.props.description && this.props.description.length > 16) ? this.renderLong() : this.renderSimple() }
        </Wrap>
      </div>);
    } // render
}// class

const mapStateToProps = state => {
  return {
    event: state.event,
    loaded: state.event.loaded,
    status: state.event.data.status,
    description: state.event.data.description,
    eventTitle: state.event.data.title,
    eventSubtitle: state.event.data.subtitle,
    eventDate: state.event.data.start_time ? new Date(state.event.data.start_time) : null,
    logoURL: state.event.data.logo ? state.event.data.logo.medium.url : false,
    registered: state.registration.loaded && state.registration.id,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setEventId: (eventId) => {
      return dispatch(EventActions.setEventId(eventId));
    },
    enableBG: () => {
      return dispatch(EventActions.enableBG());
    },
    disableBG: () => {
      return dispatch(EventActions.disableBG());
    },
    loadProfile: async () => dispatch(ProfileActions.fetchProfile()),
    setAppLoading: (val) => dispatch(AppActions.setLoading(val)),
    register: () => dispatch(EventActions.showRegisterModal()),
    login: () => dispatch(LoginActions.openLoginDialog()),
    fetchRegistration: () => dispatch(RegistrationActions.fetchRegistration()),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EventPage);
